import axios from 'axios'
import { storage } from '../../../helpers'
import { API_URL } from '../../../config'

export const exportDocumentsToExcelRequest = async ({
  searchTerm = null,
  ids = null,
  fromIssueDate = null,
  toIssueDate = null,
  fromDueDate = null,
  toDueDate = null,
  syncStatuses = null,
  pointOfWorkTags = null,
  partnerCifs = null,
  organisationCifs = null,
  pageNumber = null,
  size = null,
  statuses = null,
  categories = null,
  invoiceGroups = null,
  orderByList = null
}) => {
  const token = storage.getToken()

  const response = await axios.post(
    `${API_URL}/documents/export`,
    {
      searchTerm,
      ids,
      statuses,
      invoiceGroups,
      syncStatuses,
      categories,
      pointOfWorkTags,
      fromIssueDate,
      toIssueDate,
      fromDueDate,
      toDueDate,
      partnerCifs,
      organisationCifs,
      pagination: {
        ...(pageNumber == null || size == null
          ? { pageNumber: null, size: null }
          : { pageNumber, size }),
        orderByList
      }
    },
    {
      responseType: 'arraybuffer',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${token}`
      }
    }
  )

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })

  const contentDisposition = response.headers['content-disposition']
  const fileNameMatch = contentDisposition?.match(/filename="(.+?)"/)
  const fileName = fileNameMatch ? fileNameMatch[1] : `export_documente.xlsx`

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()

  window.URL.revokeObjectURL(url)
}
